import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { ReciboDeLuzPage } from './recibo-de-luz/recibo-de-luz.component';

let moduleName = 'cfe';

export const cfe: Routes = [
  {
    path: `${moduleName}/recibo-de-luz`,
    component: ReciboDeLuzPage,
    title: 'CFE - Recibo de luz.',
    canActivate: [authGuard, hasPermissionsGuard(['cfe_recibo_de_luz_access'])],
  },
];
